module.exports = __webpack_public_path__ + "static/img/police.9cb4d5b4.png";